import Highcharts from "highcharts";
import { GenericJavaScriptObject } from "../../interfaces/map.interfaces";

// initialize the highcharts module
require("highcharts/modules/exporting")(Highcharts);
require("highcharts/modules/export-data")(Highcharts);

// Function to generate avg charts for relative indicators
export function generateAVGLineChart(
  container: any,
  dataPerYear: GenericJavaScriptObject<any>,
  chartdisplayname: string
) {
  var indicatorName = chartdisplayname;

  const data = Object.entries(dataPerYear).map(([year, value]) => ({
    name: year,
    y: value,
  }));

  const options: GenericJavaScriptObject<any> = {
    chart: {
      type: "line",
    },
    title: {
      text: indicatorName,
    },
    xAxis: {
      categories: data.map((item) => item.name),
    },
    yAxis: {
      title: {
        text: "Indikator",
      },
    },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.y:.2f}</b><br/>",
    },
    series: [
      {
        name: "Durchschnitt Indikator",
        data: data.map((item) => item.y),
      },
    ],
  };

  Highcharts.setOptions({
    lang: {
      contextButtonTitle: "Chart Kontextmenü",
      decimalPoint: ",",
      downloadJPEG: "Als JPEG herunterladen",
      downloadPDF: "Als PDF herunterladen",
      downloadPNG: "Als PNG herunterladen",
      downloadSVG: "Als SVG herunterladen",
      downloadCSV: "Als CSV herunterladen",
      downloadXLS: "Als XLS herunterladen",
      drillUpText: "Zurück zur vorherigen Ansicht",
      loading: "Laden...",
      noData: "Keine Daten verfügbar",
      printChart: "Drucken",
      resetZoom: "Zoom zurücksetzen",
      resetZoomTitle: "Zoom zurücksetzen (1:1)",
      thousandsSep: ".",
      viewData: null as any,
      viewFullscreen: "Vollbildmodus",
    },
  });

  $(".highcharts-credits").hide();
  $(".highcharts-credits").text("Quelle: Bundesamt für Statistik (BFS)");

  Highcharts.chart(container, options);
}

// Function to generate a combination chart for absolute indicators
export function generateCombinationChart(
  container: any,
  aggregatedData: any,
  chartdisplayname: string
) {
  var indicatorName = chartdisplayname;

  const dataColumn = Object.entries(aggregatedData.sumOfIndicatorsByYear).map(
    ([year, value]) => ({
      name: year,
      y: value,
    })
  );

  const dataLine = Object.entries(aggregatedData.averageIndicatorsByYear).map(
    ([year, value]) => ({
      name: year,
      y: value,
    })
  );

  const dataPie = [
    aggregatedData.sumForYear2020,
    aggregatedData.sumOfIndicatorsByYear[2020],
  ];

  const options: GenericJavaScriptObject<any> = {
    chart: {
      type: "column",
    },
    title: {
      text: indicatorName,
    },
    xAxis: {
      categories: dataColumn.map((item) => item.name),
    },
    yAxis: {
      title: {
        text: "Indikator",
      },
    },
    plotOptions: {
      series: {
        borderRadius: "0%",
      },
      pie: {
        opacity: 0.7, // Set opacity to make the pie chart transparent
      },
    },
    series: [
      {
        name: "Summe Indikator",
        type: "line",
        step: "center",
        data: dataColumn.map((item) => item.y),
        marker: {
          lineWidth: 2,
          // @ts-ignore
          lineColor: Highcharts.getOptions().colors[4],
          fillColor: "white",
        },
      },
      {
        name: "Durchschnitt Indikator",
        type: "line",
        step: "center",
        data: dataLine.map((item) => item.y),
        tooltip: {
          pointFormat: "{series.name}: <b>{point.y:.2f}</b><br/>",
        },
        marker: {
          lineWidth: 2,
          // @ts-ignore
          lineColor: Highcharts.getOptions().colors[3],
          fillColor: "white",
        },
      },
      {
        name: "Verhältnis Auswahl",
        type: "pie",
        data: [
          {
            name: "Ausserhalb",
            y: dataPie[0],
            // @ts-ignore
            color: Highcharts.getOptions().colors[1],
            dataLabels: {
              enabled: true,
              distance: -50,
              format: "{point.total}",
              style: {
                fontSize: "12px",
              },
            },
          },
          {
            name: "Innerhalb",
            y: dataPie[1],
            // @ts-ignore
            color: Highcharts.getOptions().colors[3],
          },
        ],
        center: [60, 120],
        size: 100,
        innerSize: "70%",
        showInLegend: false,
        dataLabels: {
          enabled: false,
        },
      },
    ],
  };

  Highcharts.setOptions({
    lang: {
      contextButtonTitle: "Chart Kontextmenü",
      decimalPoint: ",",
      downloadJPEG: "Als JPEG herunterladen",
      downloadPDF: "Als PDF herunterladen",
      downloadPNG: "Als PNG herunterladen",
      downloadSVG: "Als SVG herunterladen",
      downloadCSV: "Als CSV herunterladen",
      downloadXLS: "Als XLS herunterladen",
      drillUpText: "Zurück zur vorherigen Ansicht",
      loading: "Laden...",
      noData: "Keine Daten verfügbar",
      printChart: "Drucken",
      resetZoom: "Zoom zurücksetzen",
      resetZoomTitle: "Zoom zurücksetzen (1:1)",
      thousandsSep: ".",
      viewData: undefined,
      viewFullscreen: "Vollbildmodus",
    },
  });

  $(".highcharts-credits").text("Quelle: Bundesamt für Statistik (BFS)");
  $(".highcharts-credits").hide();

  // Append the chart to the container
  Highcharts.chart(container, options);
}

// (OLD) Function to generate a line chart for absolute indicators
export function generateABSLineChart(
  container: any,
  dataPerYear: GenericJavaScriptObject<any>
) {
  var tempsettings = $("#indicatorsettingsghost").data("settings");
  var indicatorName;
  var municipality_code;
  if (tempsettings.indicator.viscategory === "Squares") {
    // check if tempsettings.indicator.name is empty else set indicatorName to "Personenanzahl"
    if (!tempsettings.indicator.name) {
      indicatorName = "Personenanzahl";
    } else {
      indicatorName = tempsettings.indicator.name;
    }
  } else {
    indicatorName = "Personenanzahl";
  }

  const initialData = Object.entries(dataPerYear.sumOfIndicatorsByYear).map(
    ([year, value]) => ({ name: year, y: value })
  );

  const options: GenericJavaScriptObject<any> = {
    chart: {
      type: "line",
    },
    title: {
      text: indicatorName,
    },
    xAxis: {
      categories: initialData.map((item) => item.name),
    },
    yAxis: {
      title: {
        text: "Indikator",
      },
    },
    series: [
      {
        name: "Summe Indikator",
        data: initialData.map((item) => item.y),
      },
    ],
    // Add a button to toggle between datasets
    exporting: {
      buttons: {
        toggleDataset: {
          text: "Summe <-> Durchschnitt",
          onclick: function () {
            const chart = this;
            // @ts-ignore
            const series = chart.series[0]; // Get the first series (Personen)
            if (series.name === "Summe Indikator") {
              // Switch to the "Average" dataset
              series.update({
                name: "Durchschnitt Indikator",
                data: Object.entries(dataPerYear.averageIndicatorsByYear).map(
                  ([year, value]) => ({
                    name: year,
                    y: value,
                  })
                ),
              });
            } else {
              // Switch back to the "sum" dataset
              series.update({
                name: "Summe Indikator",
                data: Object.entries(dataPerYear.sumOfIndicatorsByYear).map(
                  ([year, value]) => ({
                    name: year,
                    y: value,
                  })
                ),
              });
            }
          },
        },
      },
    },
  };

  Highcharts.setOptions({
    lang: {
      contextButtonTitle: "Chart Kontextmenü",
      decimalPoint: ",",
      downloadJPEG: "Als JPEG herunterladen",
      downloadPDF: "Als PDF herunterladen",
      downloadPNG: "Als PNG herunterladen",
      downloadSVG: "Als SVG herunterladen",
      downloadCSV: "Als CSV herunterladen",
      downloadXLS: "Als XLS herunterladen",
      drillUpText: "Zurück zur vorherigen Ansicht",
      loading: "Laden...",
      noData: "Keine Daten verfügbar",
      printChart: "Drucken",
      resetZoom: "Zoom zurücksetzen",
      resetZoomTitle: "Zoom zurücksetzen (1:1)",
      thousandsSep: ".",
      viewData: undefined,
      viewFullscreen: undefined,
    },
  });

  $(".highcharts-credits").text("Quelle: Bundesamt für Statistik (BFS)");
  $(".highcharts-credits").hide();

  Highcharts.chart(container, options);
}
